/* ============================================================
   OSZEA — ZEA-TEX Technology section interactions
   Vanilla JS, no dependencies. Safe to load once theme-wide.
   Re-inits on Shopify theme-editor section load.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    root = root || document;
    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    /* ---------- Scroll reveal ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      $$('.reveal').forEach(function (el) { io.observe(el); });
    } else {
      $$('.reveal').forEach(function (el) { el.classList.add('in'); });
    }

    /* ---------- Hero line reveal ---------- */
    var hero = $('.zh');
    if (hero) { setTimeout(function () { hero.classList.add('in'); }, 80); }

    /* ---------- 4-Layer Explorer (copied from Why Your Feet Stay Dry on homepage) ---------- */
    (function techLayers(){
      function setHot(i){
        $$('.tech-layer').forEach(function(l) { l.classList.toggle('hot', +l.dataset.layer===i); });
        $$('.tech-hotspot').forEach(function(s) { s.classList.toggle('hot', +s.dataset.layer===i); });
        $$('.tech-img').forEach(function(img) { img.classList.toggle('hot', +img.dataset.layer===i); });
      }
      document.addEventListener('mouseover', function(e) {
        var el = e.target.closest('.tech-layer, .tech-hotspot');
        if(el && el.dataset.layer !== undefined) setHot(+el.dataset.layer);
      });
      document.addEventListener('click', function(e) {
        var el = e.target.closest('.tech-layer, .tech-hotspot');
        if(el && el.dataset.layer !== undefined) setHot(+el.dataset.layer);
      });
    })();

    /* ---------- Centre-foot pins (click to open description) ---------- */
    $$('.zcf-pin').forEach(function (pin) {
      pin.addEventListener('click', function (e) {
        e.stopPropagation();
        var was = pin.classList.contains('open');
        $$('.zcf-pin').forEach(function (p) { p.classList.remove('open'); });
        if (!was) pin.classList.add('open');
      });
    });

    /* ---------- FAQ accordion ---------- */
    $$('.zfaq-item').forEach(function (item) {
      var q = $('.zfaq-q', item);
      var a = $('.zfaq-a', item);
      if (!q || !a) return;
      q.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
      if (item.classList.contains('open')) a.style.maxHeight = a.scrollHeight + 'px';
      q.addEventListener('click', function () {
        var open = item.classList.contains('open');
        if (open) { item.classList.remove('open'); a.style.maxHeight = '0px'; q.setAttribute('aria-expanded', 'false'); }
        else { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; q.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* close any open pin when clicking elsewhere */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.zcf-pin')) {
      Array.prototype.forEach.call(document.querySelectorAll('.zcf-pin.open'), function (p) { p.classList.remove('open'); });
    }
  });

  /* keep open FAQ heights correct on resize */
  window.addEventListener('resize', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.zfaq-item.open .zfaq-a'), function (a) {
      a.style.maxHeight = a.scrollHeight + 'px';
    });
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Shopify theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
